define('Cart.Summary.View.Stock.Status', [
    'Cart.Summary.View',
    'underscore'
], function CartSummaryViewStockStatus(
    CartSummaryView,
    _
) {
    'use strict';

    _.extend(CartSummaryView.prototype, {
        getContext: _.wrap(CartSummaryView.prototype.getContext, function parse(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var findOutofStock = _.some(ret.model.get('lines').models, function findStock(line) {
                var isPickupLine = line.getOption('custcol_bopis_store_location') &&
                    line.getOption('custcol_bopis_store_location').get('value') &&
                    line.getOption('custcol_bopis_store_location').get('value').internalid;

                return parseInt(line.get('stockStatusId'), 10) === 4 && !isPickupLine;
            });

            ret.nonStock = findOutofStock;

            return ret;
        })
    });
});

